// src/auth/authStyles.js
export const pageStyle = {
  minHeight: "100vh",
  background: "linear-gradient(160deg, #0d1117 0%, #161b22 60%, #0d1117 100%)",
  display: "flex", alignItems: "center", justifyContent: "center",
  fontFamily: "'DM Sans', sans-serif", padding: "20px",
};

export const cardStyle = {
  width: "100%", maxWidth: 420,
  background: "#161b22", border: "1px solid #21262d",
  borderRadius: 16, padding: "36px 32px",
};

export const logoStyle = {
  width: 52, height: 52, borderRadius: 14,
  background: "linear-gradient(135deg, #1f6feb, #388bfd)",
  display: "flex", alignItems: "center", justifyContent: "center",
  fontSize: 26, margin: "0 auto 12px",
};

export const headingStyle = {
  fontFamily: "'DM Serif Display', serif",
  fontSize: 26, fontWeight: 400, color: "#e6edf3", margin: "0 0 4px",
};

export const labelStyle = {
  display: "block", fontSize: 12, fontWeight: 700,
  color: "#8b949e", letterSpacing: 0.8,
  textTransform: "uppercase", marginBottom: 6,
};

export const inputStyle = {
  width: "100%", background: "#0d1117",
  border: "1px solid #30363d", borderRadius: 8,
  color: "#e6edf3", fontSize: 14, padding: "10px 13px",
  outline: "none", boxSizing: "border-box",
  fontFamily: "'DM Sans', sans-serif",
};

export const errorStyle = {
  background: "rgba(248,81,73,0.1)", border: "1px solid #f85149",
  borderRadius: 8, padding: "10px 14px",
  color: "#f85149", fontSize: 13,
};

export const successStyle = {
  background: "rgba(74,222,128,0.08)", border: "1px solid #4ade80",
  borderRadius: 8, padding: "10px 14px",
  color: "#4ade80", fontSize: 13,
};

export const btnPrimaryStyle = (disabled) => ({
  width: "100%", padding: "12px", borderRadius: 9,
  fontSize: 14, fontWeight: 700, border: "none",
  cursor: disabled ? "not-allowed" : "pointer",
  background: disabled ? "#21262d" : "linear-gradient(135deg, #1f6feb, #388bfd)",
  color: disabled ? "#484f58" : "#fff",
  transition: "all 0.2s", fontFamily: "'DM Sans', sans-serif",
  letterSpacing: 0.3,
});

export const linkBtnStyle = {
  background: "transparent", border: "none",
  color: "#8b949e", cursor: "pointer",
  fontSize: 13, padding: 0, fontFamily: "'DM Sans', sans-serif",
};

export const googleFont = (
  <link
    href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap"
    rel="stylesheet"
  />
);
